module.exports = __webpack_public_path__ + "img/notaFull.c532aec7.svg";